// localStorage can throw (QuotaExceededError/SecurityError) in Safari private
// browsing, locked-down enterprise browser configs, or sandboxed webviews.
// These wrappers swallow that so a storage failure never crashes the caller.
export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // ignore - storage unavailable or quota exceeded
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore - storage unavailable
    }
  },
};
